import { type BoundaryGroup } from '~/boundary/boundary.types';

export const checkIfBoundaryGroupIsWMSGenerated = (boundaryGroup: BoundaryGroup) => {
  return (boundaryGroup?.wms.territoriesCount ?? 0) > 0;
};

export const checkIfBoundaryGroupIsMOTGenerated = (boundaryGroup: BoundaryGroup) => {
  return (boundaryGroup?.mot.territoriesCount ?? 0) > 0;
};
